<script>
import ListForm from '../ListForm.vue'
import * as categoryService from '../../service/category.service';

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    setTopbarControls: {
      type: Function,
      required: false
    },
    topbarControls: {
      type: Object,
      required: false
    }
  },
  components: {
    ListForm,
  },
  data(){
    return {
      value: null,
      listData: new Array,
      selectedItem: new Object,
      prevSelectedItem: '{}',
      showListForm: false
}
  },
  computed: {
    totalItems() {
      return this.filteredList.length;
    },
    totalActiveItems() {
      return this.filteredList.filter((x => x.active == true)).length;
    },
    filteredList() {
      return this.listData;
    },
  },
  watch: {
    topbarControls: {
      handler: function(val) {
        if(val.title == 'Regular Hours') {
          if(val.selectedItem.id != this.selectedItem.id) {
            this.selectedItem = val.selectedItem;
          }
          if(this.listData != val.listItems) {
            this.getData()
          }
        }
      },
      deep: true
    },
  },
  methods: {
    setSelectedItems(val) {
      this.selectedItem = val;
      this.prevSelectedItem = JSON.stringify(val);
      this.setTopbarControls(null, this.listData, this.selectedItem, this.prevSelectedItem)

    },
    setListItems(val, sort) {
      if(sort) this.listData = val.sort((a, b) => a.additionalProp1.position - b.additionalProp1.position)
      else this.listData = val;
    },
    updateValue(val) {
      this.value = val;
    },
    async getData() {
      let filter = {
        "where": {
          "name": "Locations",
          "cmsId": this.$route.params.cmsId
        },
        "include": [
          {
            "relation": "pages"
          }
        ]
      };

      filter = encodeURIComponent(JSON.stringify(filter));
      
      let data = await categoryService.getWithFilter(filter)
      data = data[0];
      let list = data.pages;
      if(list && list.length) this.setListItems(list, false)
      else this.setListItems([], false)
    }
  },
  async mounted() {
    await this.getData();
  }
};
</script>
<template>
  <ListForm
      :style="item.style"
      :class="`col-${item.size} ${item.class}`"
      :item="item"
      :items="item.children"
      :selectedItem="selectedItem"
      :listItems="listData"
      :prevSelectedItem="prevSelectedItem"
      :setSelectedItems="setSelectedItems"
      :topbarControls="topbarControls"
  />
</template>

<style scoped>
 .simplebar-custom {
   max-height: calc(100vh - 300px);
   padding-right: 2em;
 }
</style>